import React from 'react';
import styled from "@emotion/styled";
import PropTypes from 'prop-types';
import {ReactComponent as Icon} from "../../assets/DevliceryBox.svg";

const ButtonWrapper = styled.div`
    width: fit-content;
    height: 36px;
    padding: 8px 16px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    /* default/gray/100 */
    /* default/gray/400 */
    border: 1px solid #CBD5E0;
    box-sizing: border-box;
    border-radius: 4px;
     
    background: var(--color-white) center;
    transition: background 0.8s;
    user-select: none;
    background: #FFFFFF;
   
    
    :hover {
      background: rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%;
    }
    
    :active {
      background-color: #767675;
      background-size: 100%;
      transition: background 0s;
    }
    
    :focus {
        outline: none
    }

    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    /* default/gray/800 */
    color: var(--color-gray-800);
`;

const IconWrapper = styled.div`
    margin-right: 4px;
`;


function IconActionButton(props) {
    const {icon, disabled} = props;
    return (
        <ButtonWrapper onClick={props.onClick} disabled={disabled}>
            <IconWrapper>
                {icon}
            </IconWrapper>
            {props.children}
        </ButtonWrapper>
    );
}

IconActionButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.any,
    disabled: PropTypes.bool,
};
IconActionButton.defaultProps = {};

export default IconActionButton;
